var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("AppNavigationItem", {
    attrs: {
      title: _vm.t("calendar", "Trash bin"),
      pinned: true,
      icon: "icon-delete"
    },
    on: {
      click: function($event) {
        $event.preventDefault()
        return _vm.onShow($event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "extra",
        fn: function() {
          return [
            _vm.showModal
              ? _c(
                  "Modal",
                  {
                    on: {
                      close: function($event) {
                        _vm.showModal = false
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "modal__content" },
                      [
                        _c("h2", [
                          _vm._v(_vm._s(_vm.t("calendar", "Trash bin")))
                        ]),
                        _vm._v(" "),
                        _vm.loading
                          ? _c("EmptyContent", {
                              staticClass: "modal__content__loading",
                              attrs: { icon: "icon-loading" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "desc",
                                    fn: function() {
                                      return [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.t(
                                                "calendar",
                                                "Loading deleted elements."
                                              )
                                            ) +
                                            "\n\t\t\t\t\t"
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                1937302202
                              )
                            })
                          : !_vm.items.length
                          ? _c("EmptyContent", {
                              staticClass: "modal__content__empty",
                              attrs: { icon: "icon-delete" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "desc",
                                    fn: function() {
                                      return [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.t(
                                                "calendar",
                                                "You do not have any deleted elements."
                                              )
                                            ) +
                                            "\n\t\t\t\t\t"
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                2497683341
                              )
                            })
                          : [
                              _c(
                                "table",
                                [
                                  _c("tr", [
                                    _c("th", { staticClass: "name" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.t("calendar", "Name")) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "deletedAt" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.t("calendar", "Deleted")) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v(" ")])
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.items, function(item) {
                                    return _c("tr", { key: item.url }, [
                                      _c("td", [
                                        _c("div", { staticClass: "item" }, [
                                          _c("div", [
                                            _c("div", {
                                              staticClass: "color-dot",
                                              style: {
                                                "background-color": item.color
                                              }
                                            })
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c("div", [
                                              _vm._v(_vm._s(item.name))
                                            ]),
                                            _vm._v(" "),
                                            item.subline
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "item-subline"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(item.subline) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "deletedAt" },
                                        [
                                          _c("Moment", {
                                            staticClass: "timestamp",
                                            attrs: { timestamp: item.deletedAt }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "button",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.restore(item)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.t("calendar", "Restore")
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "Actions",
                                            { attrs: { "force-menu": true } },
                                            [
                                              _c(
                                                "ActionButton",
                                                {
                                                  attrs: {
                                                    icon: "icon-delete"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onDeletePermanently(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.t(
                                                          "calendar",
                                                          "Delete permanently"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.retentionDuration
                                ? _c("p", { staticClass: "footer" }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.n(
                                            "calendar",
                                            "Elements in the trash bin are deleted after {numDays} day",
                                            "Elements in the trash bin are deleted after {numDays} days",
                                            _vm.retentionDuration,
                                            { numDays: _vm.retentionDuration }
                                          )
                                        ) +
                                        "\n\t\t\t\t\t"
                                    )
                                  ])
                                : _vm._e()
                            ]
                      ],
                      2
                    )
                  ]
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }